<template>
  <div>
    <b-row v-show="!isNewWorkOrder" class="text-right" align="right">
      <b-col>
        <b-form-group
          label="Status"
          label-size="sm"
          label-class="font-weight-bold"
        >
          <div class="d-flex flex-row-reverse">
            <div v-if="this.detail.waiting_approval && this.detail.status.toLowerCase().includes('waiting approval')" class="ml-4 mr-5 text-left">
              <li
                v-for="(n, i) in this.detail.waiting_approval.split(',')"
                :key="i"
                class="list-name"
              >
                {{
                  n
                }}
              </li>
            </div>
            <div class="status-full my-auto">
              <div class="status-detail"
                :class="itemRowBackground(this.detail.status)"
                size="sm"
                disabled
              >
                {{ this.detail.status }}
              </div>
            </div>
          </div>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group
          label="Contractor Name"
          label-size="sm"
          label-class="font-weight-bold"
        >
          <b-form-input
            autocapitalize="off"
            v-model="detail.contractor_name"
            placeholder="-"
            :disabled="!isNewWorkOrder"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group
          label="Department"
          label-size="sm"
          label-class="font-weight-bold"
        >
          <b-form-input
            autocapitalize="off"
            v-model="detail.department"
            placeholder="-"
            :disabled="!isNewWorkOrder"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group
          label="Contractor Number"
          label-size="sm"
          label-class="font-weight-bold"
        >
          <b-form-input
            autocapitalize="off"
            v-model="detail.contract_number"
            placeholder="-"
            :disabled="!isNewWorkOrder"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group
          label="Unit ID"
          label-size="sm"
          label-class="font-weight-bold"
        >
          <b-form-input
            autocapitalize="off"
            v-model="detail.unit_name"
            placeholder="-"
            :disabled="!isNewWorkOrder"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group
          label="WO Number"
          label-size="sm"
          label-class="font-weight-bold"
        >
          <b-form-input
            autocapitalize="off"
            v-model="detail.wo_number"
            placeholder="-"
            :disabled="!isNewWorkOrder"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group
          label="Unit Type"
          label-size="sm"
          label-class="font-weight-bold"
        >
          <b-form-input
            autocapitalize="off"
            v-model="detail.unit_type"
            placeholder="-"
            :disabled="!isNewWorkOrder"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group
          label="Budget Code"
          label-size="sm"
          label-class="font-weight-bold"
        >
          <b-form-input
            autocapitalize="off"
            v-model="detail.budget_code"
            placeholder="-"
            :disabled="!isNewWorkOrder"
          />
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group
          label="Period"
          label-size="sm"
          label-class="font-weight-bold"
        >
          <b-input-group>
            <b-form-input
              v-model="detail.periode_start"
              type="text"
              placeholder="-"
              autocomplete="off"
              disabled
            ></b-form-input>
            <b-input-group-append>
              <b-form-datepicker
                v-model="detail.periode_start"
                button-only
                left
                locale="en-US"
                size="sm"
                aria-controls="example-input"
                :disabled="!isNewWorkOrder"
              ></b-form-datepicker>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group label="" label-size="sm" label-class="font-weight-bold">
          <br />
          <b-input-group>
            <b-form-input
              v-model="detail.periode_end"
              type="text"
              placeholder="-"
              autocomplete="off"
              disabled
            ></b-form-input>
            <b-input-group-append>
              <b-form-datepicker
                v-model="detail.periode_end"
                button-only
                left
                locale="en-US"
                size="sm"
                aria-controls="example-input"
                :disabled="!isNewWorkOrder"
              ></b-form-datepicker>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    detail: {
      types: Object,
      default: () => ({
        contractor_name: '',
        contract_number: '',
        wo_number: '',
        budget_code: '',
        department: '',
        unit_type: '',
        unit_name: '',
        periode_start: '',
        periode_end: '',
        job_desc: '',
        status: ''
      })
    },
    isNewWorkOrder: {
      types: Boolean,
      default: () => false
    }
  },
  methods: {
    itemRowBackground(status) {
      if (status === 'Draft') {
        return 'draft'
      } else if (status === 'Approved') {
        return 'approved'
      } else if (status === 'Revise') {
        return 'revised'
      } else if (status === 'Waiting Approval') {
        return 'waiting-approval'
      } else {
        return 'waiting-approval'
      }
    }
  }
}
</script>

<style scoped>
.list-name{
  font-size: 14px;
}
.status-full{
  width: 70%;
}
</style>
